import { createSelector } from 'reselect';

const selectReconciliations = (state: any) => state.reconciliations;


export const selectReconciliationCurrentItem = createSelector([selectReconciliations], (reconciliations) => reconciliations.current);

export const selectReconciliationsListItems = createSelector([selectReconciliations], (reconciliations) => reconciliations.list);

export const selectReconciliationItemById = (itemId: any) =>
    createSelector(selectReconciliationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectReconciliationQueryItems = createSelector([selectReconciliations], (reconciliations) => reconciliations.query);

export const selectReconciliationCreatedItem = createSelector([selectReconciliations], (reconciliations) => reconciliations.create);

export const selectReconciliationUpdatedItem = createSelector([selectReconciliations], (reconciliations) => reconciliations.update);

export const selectReconciliationReadItem = createSelector([selectReconciliations], (reconciliations) => reconciliations.read);

export const selectReconciliationDeletedItem = createSelector([selectReconciliations], (reconciliations) => reconciliations.delete);

export const selectReconciliationSearchedItems = createSelector([selectReconciliations], (reconciliations) => reconciliations.search);

export const selectReconciliationItemsCount = createSelector([selectReconciliations], (reconciliations) => reconciliations.count);

export const selectReconciliationItemsFilter = createSelector([selectReconciliations], (reconciliations) => reconciliations.filter);